import { apiClient } from './axiosInstance';
import {
  IAddBulkTimeEntryData,
  IAddTimeEntryData,
  IEditTimeEntryData
} from 'features/timeEntries/timeEntriesTypes';
import { IGetMemberEventsData } from 'features/calendarInfo/calendarInfoTypes';

export const fetchMemberTimeEntries = async (data: IGetMemberEventsData) => {
  const startDateQuery = encodeURIComponent(data.start);
  const endDateQuery = encodeURIComponent(data.end);
  const timeZoneQuery = encodeURIComponent(data.timeZoneName);
  return await apiClient.get(
    `/time-entries/${data.id}?startDate=${startDateQuery}&endDate=${endDateQuery}&timeZone=${timeZoneQuery}`
  );
};

export const createTimeEntry = async (data: IAddTimeEntryData) => {
  return await apiClient.post(`/time-entries/${data.memberId}`, {
    projectId: data.projectId,
    start: data.start,
    note: data.note,
    isBillable: data.isBillable,
    end: data.end,
  });
};

export const createBulkTimeEntry = async (data: IAddBulkTimeEntryData) => {
  return await apiClient.post(`/time-entries/bulk/${data.memberId}`, {
    projectId: data.projectId,
    dates: data.dates,
    note: data.note,
    isBillable: data.isBillable,
  });
};

export const editTimeEntry = async (data: IEditTimeEntryData) => {
  return await apiClient.put(
    `/time-entries/${data.memberId}/${data.timeEntryId}`,
    {
      projectId: data.projectId,
      start: data.start,
      end: data.end,
      isBillable: data.isBillable,
      note: data.note,
      timeZone: data.timeZone,
    }
  );
};

export const removeTimeEntry = async (timeEntryId: number) => {
  return await apiClient.delete(`/time-entries/${timeEntryId}`);
};

export const removeTimeEntryGroup = async (groupId: string) => {
  return await apiClient.delete(`/time-entries/group/${groupId}`);
};
